import './cloudBackground.css';

export default function CloudBackground() {
    return(
        <div>
            <svg width="1392.345" height="934.986" viewBox="0 0 1392.345 934.986">
                <g id="Group_46" data-name="Group 46" transform="translate(-267.655 -2571.66)">
                    <circle id="Ellipse_31" data-name="Ellipse 31" cx="170.348" cy="170.348" r="170.348" transform="translate(267.655 2881.866) rotate(-13)" fill="#77b6db"/>
                    <circle id="Ellipse_32" data-name="Ellipse 32" cx="170.348" cy="170.348" r="170.348" transform="translate(1162.395 2916.645) rotate(-13)" fill="#77b6db"/>
                    <path id="Icon_fa-solid-cloud" data-name="Icon fa-solid-cloud" d="M0,632.634c0,164.854,133.749,298.6,298.6,298.6h763.1c146.606,0,265.425-118.819,265.425-265.425,0-128.358-91.24-235.565-212.34-260.033a200.446,200.446,0,0,0,13.271-71.748c0-109.9-89.166-199.068-199.068-199.068a198.053,198.053,0,0,0-110.524,33.593C761.022,69.021,653.816,2.25,530.849,2.25c-183.309,0-331.781,148.472-331.781,331.781,0,5.6.207,11.2.415,16.8C83.36,391.678,0,502.41,0,632.634Z" transform="translate(329.877 2572.41)" fill="#88cdf6" stroke="#77b6db" stroke-width="6"/>
                </g>
            </svg>
        </div>
    )
}